var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "2.625rem",
    height: "2.625rem",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    color: "var(--gBHQLb)"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 6a1 1 0 011-1h2a1 1 0 110 2H9a1 1 0 01-1-1zM9 9a1 1 0 000 2h6a1 1 0 100-2H9z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 1a1 1 0 00-1 1v3.126C2.275 5.57 1 7.136 1 9v9a5 5 0 005 5h12a5 5 0 005-5V9a4.002 4.002 0 00-3-3.874V2a1 1 0 00-1-1H5zm15 6.268V12a1 1 0 01-.606.92l-7 3a1 1 0 01-.788 0l-7-3A1 1 0 014 12V7.268A2 2 0 003 9v9a3 3 0 003 3h12a3 3 0 003-3V9a2 2 0 00-1-1.732zM6 11.34V3h12v8.34l-6 2.572-6-2.571z",
    fill: "currentColor"
  })));
}
export default SvgMail;